import { Address } from './address.model';
import { Department } from './department.model';
import { Event } from './event.model';
import { Measure } from './measure.model';
import { GeoDsMeta } from './meta-data.model';

export class SubProject extends GeoDsMeta {
  ParentId: string;
  Designation: string;
  State: string;
  StartDate: Date;
  EndDate: Date;
  Description: string;
  Label?: string;
  Event?: Event;
  Highlights?: string;
  Lowlights?: string;
  IdRefResponsible?: string;
  IdRefResponsibleSupport?: string;
  ImplementationStatus?: string;
  Company?: Address;
  Department?: Department;
  measures?: Measure[];
  constructor(data) {
    super();
    Object.assign(this, data);
  }
}
